import data from 'dsv!../../data/interface_terms.csv';
import {langs, langsNative} from './langs';

let mappedTerms = {};
let t = translate;

Object.freeze(langs);
Object.freeze(langsNative);

data.forEach(function (item){
    mappedTerms[item.en.toLowerCase()] = item;
});

/*
* Trnaslates text from english to a given language
* @param  {[type]} text [description]
* @param  {[type]} lang [description]
* @return {[type]}      [description]
*/
function translate(text, lang) {
    let maybeText;
    text = text.toLowerCase();
    if (text in mappedTerms){
        if (lang in mappedTerms[text]) {
            maybeText = mappedTerms[text][lang];
            if (maybeText !== ''){
                return mappedTerms[text][lang];
            }
        }
    }
    return titleCase(text);
}

/**
 * Returns a language list array in a given tgtLang, e.g. list of languages as they are in spanish
 * @param  {[type]} tgtLang [description]
 * @return {array}         [description]
 */
function langsForLang(tgtLang) {
    let translatedLang;
    let langArr = [];
    for (var key in langs){
        if ({}.hasOwnProperty.call(langs, key)) {
            translatedLang = translate(langs[key], tgtLang);
            if (translatedLang !== ''){
                let obj = {};
                obj[key] = translatedLang;
                langArr.push(obj);
            }
        }
    }
    return langArr.sort(sortLangs);
}


function sortLangs (a, b){
    let kA = Object.keys(a)[0];
    let kB = Object.keys(b)[0];
    let textA = a[kA].toLowerCase();
    let textB = b[kB].toLowerCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
}

function titleCase (str) {
   var splitStr = str.toLowerCase().split(' ');
   for (var i = 0; i < splitStr.length; i++) {
       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
   }
   return splitStr.join(' ');
}

export {translate, t, langs, langsNative, langsForLang, titleCase};



/** WEBPACK FOOTER **
 ** ./src/translate/index.js
 **/